import React, { useState, useEffect } from "react";

const AddOnWidget = (props) => {
    const [ quantity, setQuantity ] = useState(0);

    useEffect(() => {
        if (props.addOns !== undefined) {
            setQuantity(props.addOns);
        }
    }, []);

    useEffect(() => {
        if (props.onQuantityChange !== undefined && props.onQuantityChange !== null) {
            props.onQuantityChange.apply(this, [props.plan, quantity]);
        }
    }, [quantity]);

    useEffect(() => {
        if (props.reset && (quantity !== props.addOns)) {
            setQuantity(props.addOns);
        }
    }, [props.reset]);

    let label = quantity,
        counts = props.counts || 'social profiles';

    if (props.labelMaker !== undefined) {
        label = props.labelMaker.apply(this, [props.plan, quantity]);
    }

    return (
        <div className="add-on-widget">
            <button type="button" className="decrease" aria-label={`Fewer ${counts}`} onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                if (quantity > 0) {
                    setQuantity(quantity - 1);
                }
            }}>
                <i className="icon ion-minus" aria-hidden="true"/>
            </button>
            <div className="quantity-display" role="status">
                {label}
            </div>
            <button type="button" className="increase" aria-label={`More ${counts}`} onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                setQuantity(quantity + 1);
            }}>
                <i className="icon ion-plus" aria-hidden="true"/>
            </button>
        </div>
    );
};

export default AddOnWidget;
